import { render, staticRenderFns } from "./_contactPreferences.vue?vue&type=template&id=1abcb6e8"
import script from "./_contactPreferences.vue?vue&type=script&lang=js"
export * from "./_contactPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports